import React from "react";
import RolesTable from "./RolesTable";

// No filters on this page: the table takes the whole width
const RolesContainer: React.FC = () => (
  <div className="lp-layout filters-hidden">
    <RolesTable/>
  </div>
);

export default RolesContainer;
